import React from "react";
import audience from "../../../assets/products/audience.png";
import privacy from "../../../assets/products/privacy.png";
import time from "../../../assets/products/time.png";

const UserDesign = () => {
  const data = [
    {
      id: 1,
      title: "Audience Size is not a problem",
      description:
        "No matter the scale of your audience, our platform scales effortlessly. Whether you're reaching hundreds or millions, we ensure your data is always handled with precision and speed, so you can focus on making an impact.",
      img: audience,
    },
    {
      id: 2,
      title: "Privacy Ensured",
      description:
        "Your data's security and privacy are paramount. With state-of-the-art encryption and strict privacy controls, you have complete peace of mind. Your webcam’s data remains yours, and we're here to protect it.",
      img: privacy,
    },
    {
      id: 3,
      title: "Time and Cost Efficiency",
      description:
        "Time is money, and we understand that. Our platform is designed to save you both.",
      img: time,
    },
  ];
  return (
    <section className="gray-background-bg d-flex justify-content-center">
      <div className="product-components-max-width">
        <h1 className="primary-light-text User-centered-Design">User-centered Design</h1>
        {data.map((data) => (
          <div key={data.id} className="row insights-card">
            <div className="col-lg-4 col-md-6">
              <img src={data.img} alt="" />
            </div>
            <div className="col-lg-8 col-md-6">
              <h6 className="primary-light-text">{data.title}</h6>
              <p className="secondary-light-text">{data.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UserDesign;
